import AdminRouteContainer from "./AdminRouteContainer";

export default AdminRouteContainer;
